import React, { memo, useState, useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import '../../../../node_modules/video-react/dist/video-react.css';
import { Player, ControlBar, BigPlayButton, Shortcut } from 'video-react';

import styles from './GameExtScreen.module.less';
import { CONTEXT } from '../../../config';
import { logPostInfo, logging } from '../../../actions/log';
import { setIframeVisible } from '../../../actions/layout';
import { logNative, getUrlByTargetContent } from '../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectGameInfo = createSelector(
  state => state.game,
  game => game,
);
export default memo(({ data, logInfo, handleScrollAdv, isShowAdv }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const { gameExtScreen } = useSelector(selectGameInfo);

  const [player, setPlayer] = useState(null);
  const [showPlayer, setShowPlayer] = useState(true);

  const LOG_ACTION_SOURCE = {
    c_action: `${logInfo.clTag || logInfo.tag}_Negative_Screen`,
    c_close: `${logInfo.clTag || logInfo.tag}_Negative_Screen_Close`,
    source: `${logInfo.tag}_Negative_Screen`,
  };
  let targetContent_ = {};
  try {
    targetContent_ = JSON.parse(gameExtScreen?.data?.targetContent || '{}');
  } catch (error) {}

  useActivate(() => {
    setShowPlayer(true);
  });
  useUnactivate(() => {
    setShowPlayer(false);
  });

  useEffect(() => {
    if (!isShowAdv) return;

    dispatch(
      logging({
        category: 'P',
        action: LOG_ACTION_SOURCE.c_action,
        label: '',
        param2: {
          source: `${LOG_ACTION_SOURCE.source}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: gameExtScreen?.data?.targetType,
          id: { ...targetContent_ },
        },
        param3: gameExtScreen?.data?.bizInfo,
      }),
    );
  }, [isShowAdv]);
  const handleHiddle = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof handleScrollAdv === 'function') {
        handleScrollAdv('hidden');
        dispatch(
          logging({
            category: 'C',
            action: LOG_ACTION_SOURCE.c_close,
            label: '',
            param2: {
              source: `${LOG_ACTION_SOURCE.source}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              type: gameExtScreen?.data?.targetType,
              id: { ...targetContent_ },
            },
            param3: gameExtScreen?.data?.bizInfo,
          }),
        );
      }
    },
    [logInfoData, gameExtScreen],
  );

  const handleAdv = useCallback(
    bannerInfo => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_action,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: gameExtScreen?.data?.targetType,
            id: { ...targetContent_ },
          },
          param3: bannerInfo.bizInfo,
        }),
      );
      if (
        bannerInfo.targetType === '1' ||
        bannerInfo.targetType === '3' ||
        bannerInfo.targetType === '11'
      ) {
        dispatch(
          logPostInfo({
            source_p: `${LOG_ACTION_SOURCE.source}`,
            source_pp: logInfoData.source_p,
          }),
        );
        let url = `${CONTEXT}/`;
        if (bannerInfo.targetType && bannerInfo.targetContent) {
          url = getUrlByTargetContent(bannerInfo);
        }
        history.push(url);
      } else if (bannerInfo.targetType === '2') {
        if (bannerInfo.targetUrl) {
          window.open(bannerInfo.targetUrl);
        } else if (bannerInfo.targetContent) {
          try {
            const targetContent = JSON.parse(bannerInfo.targetContent) || {};
            window.open(targetContent.targetUrl);
          } catch (error) {}
        }
      } else if (bannerInfo.targetType === '5' && bannerInfo.targetContent) {
        let targetContent = {};
        try {
          targetContent = JSON.parse(bannerInfo.targetContent);
        } catch (error) {
          logNative(`分析商城URL JSON解析错误:${error}`, error);
        }
        if (targetContent && targetContent.url) {
          dispatch(
            setIframeVisible({
              visible: true,
              url: targetContent.url,
              source: LOG_ACTION_SOURCE.source,
            }),
          );
        }
      } else {
        history.push(`${CONTEXT}/error`);
      }
    },
    [dispatch, logInfoData, history],
  );

  return (
    <div
      className={styles.extscreen}
      onClick={() => {
        handleAdv(gameExtScreen?.data);
      }}
    >
      <div className={`extscreen_bg_box`}>
        <img className={`extscreen_bg`} src={gameExtScreen?.data?.img} />
      </div>
      {gameExtScreen?.data?.videoUrl && (
        <div className={`extscreen_video`}>
          {showPlayer && (
            <Player
              src={`${gameExtScreen?.data?.videoUrl}`}
              poster={gameExtScreen?.data?.img}
              ref={p => setPlayer(p)}
              className={styles.player}
              playsInline={true}
              fluid={false}
              autoPlay={true}
              muted={true}
              loop={true}
              width={`100%`}
              height={`100%`}
            >
              <Shortcut clickable={false} dblclickable={false} />
              <BigPlayButton position="center" className={styles.player_btn} />
              <ControlBar
                disableCompletely={true}
                disableDefaultControls={true}
                className={styles.player_controlbar}
              />
            </Player>
          )}
        </div>
      )}
      {!gameExtScreen?.data?.videoUrl && gameExtScreen?.data?.img && (
        <img className={`extscreen_img`} src={gameExtScreen?.data?.img} />
      )}
      <div className={`extscreen_bg_2`}></div>
      <div className={`extscreen_bottom`}>
        <div className={`extscreen_bottom_p`} onClick={handleHiddle}></div>
      </div>
      <div className={`extscreen_infos`}>
        <div className={`extscreen_infos_name`}>{gameExtScreen?.data?.title}</div>
        <div className={`extscreen_infos_desc`}>{gameExtScreen?.data?.desc}</div>
        <div className={`extscreen_infos_btn`}>{gameExtScreen?.data?.buttonTitle}</div>
      </div>
    </div>
  );
});
